export { default as CustomerDataFields } from './CustomerDataFields';
export { default as PersonalisationDataFields } from './PersonalisationDataFields';
export { default as CustomerRegister } from './CustomerRegister';
export { default as CustomerUpdate } from './CustomerUpdate';
export { default as NewsletterRegister } from './NewsletterRegister';
